import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RealizeEvaluationPage } from './realize-evaluation';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    RealizeEvaluationPage,
  ],
  imports: [
    FormsModule,
    IonicPageModule.forChild(RealizeEvaluationPage),
  ],
})
export class RealizeEvaluationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/avalicorp-realize-evaluation/realize-evaluation.module.ts